// extracted by mini-css-extract-plugin
module.exports = {"form-layout":"VerifyEmailForm_form-layout__oBVYL","submit-button":"VerifyEmailForm_submit-button__3E5wo"};